import React, { useEffect } from "react";
import { useFetchRosterOwnerLovQuery } from "stores/apis/apiSlice";
import {
  fetchManageCommittee,
  manageCommitteeSelector,
  setSelectedAssociationFilter,
  setSelectedObjectTypeFilter
} from "stores/redux/slice/manageCommitte";
import Layout from "../Layout";
import Browser from "./Browser";
import MatchingPersonRoles from "./MatchingPersonRoles";
import Participants from "./Participants";

import csmKeys from "assets/text/csmKeys";
import useGetFromAppConfig, { useRosterPermission } from "helpers/getAppConfig";
import { keyValueList } from "helpers/utils";
import { useDispatch, useSelector } from "react-redux";

const all = { label: "All", value: "" };

export default function ManageCommittees() {
  const data = useSelector(manageCommitteeSelector);
  const { data: rosterOwnerLov, isLoading: isLoadingRosterOwnerLov } = useFetchRosterOwnerLovQuery();
  const objectTypeLov = useGetFromAppConfig("LOV_MC_OBJECT_TYPE", "objectTypeList");
  const hasEditPermission = useRosterPermission(csmKeys.ROSTERING_COMMITTEES_SETUP_EDIT);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchManageCommittee());
    return () => {
      dispatch(setSelectedObjectTypeFilter(all));
      dispatch(setSelectedAssociationFilter(all));
    };
  }, [dispatch]);

  if (isLoadingRosterOwnerLov) {
    return <div>Loading...</div>;
  }
  const associationLov = keyValueList(data, "esysId");
  return (
    <Layout>
      <Browser
        rows={data}
        rosterOwnerLov={rosterOwnerLov}
        objectTypeLov={objectTypeLov}
        associationLov={associationLov}
        hasEditPermission={hasEditPermission}
      />
      <div className="row">
        <div className="col-5">
          <MatchingPersonRoles />
        </div>
        <div className="ml-2 col-7">
          <Participants hasEditPermission={hasEditPermission} />
        </div>
      </div>
    </Layout>
  );
}
